import { createReducer } from '@reduxjs/toolkit';
import { ILocationState } from './types';
import { fetchLocationList } from './actions';

const initialState: ILocationState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};

export const locationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchLocationList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchLocationList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchLocationList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});
